import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './OrderSuccess.css';

export default function OrderSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderNumber = searchParams.get('order');

  return (
    <div className="order-success-page">
      <motion.div
        className="order-success-container"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="success-icon"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
        >
          ✓
        </motion.div>

        <h1 className="success-title">Order Placed Successfully!</h1>

        {orderNumber && (
          <p className="order-number">Order Number: <strong>{orderNumber}</strong></p>
        )}

        <p className="success-message">
          Thank you for your purchase. We've received your order and will begin processing it shortly.
          You'll receive an email confirmation with your order details.
        </p>

        <div className="success-actions">
          <motion.button
            className="btn-primary"
            onClick={() => navigate('/profile?tab=orders')}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            View My Orders
          </motion.button>
          <motion.button
            className="btn-secondary"
            onClick={() => navigate('/design')}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Design Another Lamp
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
}
